import { UserType } from "../../services/entities/User";
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { clearWayupApiSession } from "@repo/core/stores/wayupApiAuth";
import { clearUnicoSession } from "@repo/core/stores/unico";
import { useTerminalActiveStore } from "@repo/core/stores/terminalActive";
import {
  invalidateSession,
  resumeSession
} from "@repo/core/services/session/sessionEpoch";

interface AuthState {
  isAuthenticated: boolean;
  user: UserType | null;
  login: (user: UserType) => void;
  logout: () => void;
}

const initialValues = {
  isAuthenticated: false,
  user: null
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      ...initialValues,
      login: (user: UserType) => {
        resumeSession();
        return set({ isAuthenticated: true, user });
      },
      logout: () => {
        invalidateSession();
        clearWayupApiSession();
        clearUnicoSession();
        const { cleanData } = useTerminalActiveStore.getState();
        cleanData();

        set(initialValues);
      }
    }),
    {
      name: "AuthStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);

export default useAuthStore;
